import script from "./OffSchedulePage.vue?vue&type=script&setup=true&lang=js"
export * from "./OffSchedulePage.vue?vue&type=script&setup=true&lang=js"

import "./OffSchedulePage.vue?vue&type=style&index=0&id=4731ec2e&lang=less"

const __exports__ = script;

export default __exports__